import { useState } from "react";
import { History } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@opencloud/ui";
import { Markdown } from "./Markdown.js";

/**
 * One compact line for the summary a Codex root reads when it continues
 * without its earlier session (after an interrupted turn or a model or engine
 * switch). The summary stays in the conversation for later roots, but it is
 * not the agent's reply, so it is folded away until someone opens it.
 */
export function ContextSummaryNote({ summary, messageId, focused }: {
  summary: string;
  messageId: string;
  focused: boolean;
}) {
  // A search result inside the summary opens it, so the match is visible.
  const [open, setOpen] = useState(focused);
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      id={`message-${messageId}`}
      data-message-id={messageId}
      data-search-focus={focused || undefined}
      className="a3-context-summary"
      role="note"
    >
      <div className="a3-context-summary-line">
        <span>
          <History aria-hidden="true" />
          The agent continued from a summary of this chat, so it may not remember every detail.
        </span>
        <CollapsibleTrigger className="a3-context-summary-toggle">
          {open ? "Hide summary" : "Show summary"}
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent className="a3-context-summary-text">
        <Markdown>{summary}</Markdown>
      </CollapsibleContent>
    </Collapsible>
  );
}
